module.exports = __webpack_public_path__ + "img/ic-contact-line.60ea3d53.png";